import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { Box, Button, Stack, Typography, styled } from "@mui/material";
import { ApiUrls, urlAddTicketPage } from "services/utils/globalVariables";
import TicketCard from "components/datadisplay/cards/TicketCard";
import AddCommentOutlinedIcon from '@mui/icons-material/AddCommentOutlined';
import { useContextState } from "services/context/MainContext";
import { ChatListLoader } from "components/loaders/ChatLoaders";
import noTicketImage from "../assets/images/no-ticket.svg"
import { NoTicketText } from "components/typography/text";

const SupportContainer = styled(Stack)(
    ({ theme }) => `
        width: 100%;
        height: 100%;
        margin-top: ${theme.spacing(3)};
        padding: 0 16px;
        // justify-content: space-between;
    `
)
const SupportTicketsContainer = styled(Stack)(
    ({ theme }) => `
        width: 100%;
        height: calc(100vh - 240px);
        overflow-y: auto;
    `
)
const SupportTicketButton = styled(Button)(
    ({theme}) => `
        width: 100%;
        color: ${theme.palette.secondary.main} !important;
        margin-top: ${theme.spacing(3)};
        font-weight: bolder;
    `
)
const NoTicketContainer = styled(Stack)(
    ({theme}) => `
        width: 100%;
        padding: 32px 0;
        justify-content: center;
        align-items: center;
        & img {
            width: 270px;
            height: auto;
        }
    `
)

export default function SupportPage() {

    const { ticketList } = useContextState()
    const navigate = useNavigate()

    return (
        <Stack sx={{direction: "ltr !important", height: "calc(100vh - 160px)"}}>
            <SupportContainer spacing={2} >
                <SupportTicketsContainer spacing={2} >

                {
                    ticketList ?
                        ticketList.map((val, i) => {
                            return <TicketCard key={i} data={val} />
                        })
                    : 
                        <ChatListLoader />
                }
                {
                    ticketList.length == 0 &&
                    <NoTicketContainer spacing={3} >
                        <img src={noTicketImage} />
                        <NoTicketText>در این صفحه تیکتی ایجاد نشده است.</NoTicketText>
                    </NoTicketContainer>
                }
                </SupportTicketsContainer>
                <SupportTicketButton size="large" color="primary" variant="contained" onClick={() => navigate(`${urlAddTicketPage}`)} >
                    <AddCommentOutlinedIcon sx={{mr: 1}} />
                    ایجاد تیکت
                </SupportTicketButton>
            </SupportContainer>
        </Stack>
    )
}